import ReactGA from 'react-ga4';

export const addAnalytics = (category, message, data) => {
    console.log("ADDANALYTICS",category, message, data);
    ReactGA.event({
        category: category,
        action: message,
        label: data && typeof data === "object" ? JSON.stringify(data) : data,
    });
}

//export default addAnalytics;


export function paginationAnalytics(currentPage, totalPages, category, message) {
    console.log(`Page ${currentPage +1 } of ${totalPages}`)
    ReactGA.event({
        category: message,
        action: category +"Pagination",
        label: `Page ${currentPage +1 } of ${totalPages}`,
    });
   
}


